export const MAX_HOLDS_IN_LEAD_ROUTE = 30;
export const MAX_HOLDS_IN_LONG_LEAD_ROUTE = 35;
export const MAX_TIME_ON_LEAD_ROUTE = 5 * 60;
export const MAX_TRIES_ON_BOULDER_ROUTE = 100;

export const LONG_LEAD_ROUTES: number[] = [];

export const ROUTE_CATEGORIES = ['boulder', 'lead'] as const;
export type RouteCategory = (typeof ROUTE_CATEGORIES)[number];

export enum View {
  grading,
  results,
  registration,
}

export const viewRoutes = {
  [View.results]: '/',
  [View.grading]: '/grading',
  [View.registration]: '/registration',
};

export enum Role {
  public = 'public',
  grading = 'grading',
  admin = 'admin',
}

export const viewAuthorizedRoles: Record<View, Role[]> = {
  [View.results]: [Role.admin, Role.grading, Role.public],
  [View.grading]: [Role.admin, Role.grading],
  [View.registration]: [Role.admin],
};

export enum ClimberCategory {
  'U9 Boys' = 'U9 Boys',
  'U9 Girls' = 'U9 Girls',
  'U11 Boys' = 'U11 Boys',
  'U11 Girls' = 'U11 Girls',
  'U13 Boys' = 'U13 Boys',
  'U13 Girls' = 'U13 Girls',
  'U15 Boys' = 'U15 Boys',
  'U15 Girls' = 'U15 Girls',
  'U17 Boys' = 'U17 Boys',
  'U17 Girls' = 'U17 Girls',
  'U19 Boys' = 'U19 Boys',
  'U19 Girls' = 'U19 Girls',
  'U21 Boys' = 'U21 Boys',
  'U21 Girls' = 'U21 Girls',
}

export type ResultCategory = ClimberCategory | 'clubs';
